import {isNode} from './index'

export const C_MID_KEY = 'blue_mid'
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365

function generateCMid() {
  const randomUUID =
    typeof crypto !== 'undefined'
      ? (crypto as {randomUUID?: () => string}).randomUUID
      : undefined
  if (typeof randomUUID === 'function') {
    return randomUUID()
  }
  return `c_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`
}

export function getCMidFromCookie(cookieHeader?: string): string {
  const raw = isNode()
    ? cookieHeader || ''
    : typeof document !== 'undefined'
    ? document.cookie
    : ''
  const match = raw.match(new RegExp(`(?:^|;\\s*)${C_MID_KEY}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : ''
}

function persistCookie(cMid: string) {
  try {
    const secure = window.location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = `${C_MID_KEY}=${encodeURIComponent(
      cMid
    )}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax${secure}`
  } catch (e) {}
}

export function getCMid(): string {
  if (isNode()) {
    return ''
  }
  try {
    let cMid = localStorage.getItem(C_MID_KEY) || getCMidFromCookie()
    if (!cMid) {
      cMid = generateCMid()
    }
    localStorage.setItem(C_MID_KEY, cMid)
    persistCookie(cMid)
    return cMid
  } catch (e) {
    return ''
  }
}
